import React from 'react';
import { Users, Calendar, TrendingUp, Receipt } from "lucide-react";

// Simple Card components
const Card = ({ children, className = "" }) => (
  <div className={`bg-white rounded-lg shadow-sm border ${className}`}>
    {children}
  </div>
);

const CardContent = ({ children, className = "" }) => (
  <div className={`px-6 py-4 ${className}`}>
    {children}
  </div>
);

export default function DashboardStats({ stats }) {
  const statCards = [
    {
      title: "Total Doctors",
      value: stats.totalDoctors,
      icon: Users,
      bgColor: "from-blue-500 to-blue-600",
      textColor: "text-blue-600"
    },
    {
      title: "Today's Visits",
      value: stats.visitsToday,
      icon: Calendar,
      bgColor: "from-green-500 to-green-600",
      textColor: "text-green-600"
    },
    {
      title: "This Week",
      value: stats.visitsThisWeek,
      icon: TrendingUp,
      bgColor: "from-purple-500 to-purple-600",
      textColor: "text-purple-600"
    },
    {
      title: "Pending Expenses",
      value: stats.pendingExpenses,
      icon: Receipt,
      bgColor: "from-orange-500 to-orange-600",
      textColor: "text-orange-600"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {statCards.map((stat, index) => (
        <Card key={index} className="relative overflow-hidden shadow-lg border-0 bg-white/80 backdrop-blur-sm">
          <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br ${stat.bgColor} opacity-10 rounded-full transform translate-x-6 -translate-y-6`} />
          <CardContent className="p-6">
            <div className="flex justify-between items-start">
              <div>
                <p className="text-sm font-medium text-gray-500 mb-2">{stat.title}</p>
                <p className="text-3xl font-bold text-gray-900">{stat.value}</p>
              </div>
              <div className={`p-3 rounded-xl bg-gradient-to-br ${stat.bgColor} bg-opacity-10`}>
                <stat.icon className={`w-6 h-6 ${stat.textColor}`} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
